import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getWebUISettings, getSettingsIntegration } from 'actions/EntityActions';
import Breadcrumb from 'screens/components/basic/Breadcrumb';
import { integrationCrumb } from 'utils/breadcrumbInfo';
import { Card, Divider, CardContent } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Header from './header'
import 'styles/sass/integration/index.scss'


class IntegrationOverview extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentWillMount() {
        this.props.getWebUISettings(this.props.branchId, "integrationOverview");
        this.props.getSettingsIntegration(this.props.branchId);
    }

    componentDidUpdate(prevProps) {

    }

    createRows = () => {
        let integrationList = [...this.props.integrationList]

        if (this.props.selectedType != "0") {
            integrationList = integrationList.filter(item => item.type.includes(this.props.selectedType))
        }
        if (this.props.nameFilter != "" && this.props.nameFilter != undefined) {
            integrationList = integrationList.filter(item => item.name.toLowerCase().includes(this.props.nameFilter))
        }

        let cardList = [[]];
        let i = 0;
        integrationList.forEach((item, index) => {
            let isThird = (index + 1) % 3 == 0;
            let style = {};
            let fontSize = { fontSize: "15" };

            if (isThird) {
                style = { width: "33%", minHeight: "30vh", height: "30vh" };
            } else {
                style = { width: "33%", minHeight: "30vh", height: "30vh", marginRight: '0.5%' };
            }

            let card =
                <Card className="integrationCard" key={item.name}>
                    <CardContent>
                        <div className="image">
                            <img src={item.imgLink} className="integration-vendor-icon" />
                        </div>
                        <div className="content">
                            <h4>{item.name}</h4>
                            <p>{item.type.join(" & ")}</p>
                            <div style={{ overflow: "auto", maxHeight: "13vh", height: "13vh" }}>
                                <p style={fontSize}>{item.description}</p>
                            </div>
                            <Divider />
                            <div className="active-area">
                                <p>{item.active ? 'Active' : 'InActive'}</p>
                                {item.active ? (
                                    <CheckCircleIcon className="text-success" style={{ color: 'green' }} />
                                ) : (
                                    <CancelIcon className="text-danger" style={{ color: 'red' }} />
                                )}
                            </div>

                        </div>
                    </CardContent>
                </Card>;

            cardList[i].push(card);
            if (isThird) {
                cardList.push([]);
                i++;
            }
        })

        let cardRows = cardList.map((item, index) => {
            return (
                <React.Fragment key={index}>
                    {item}
                </React.Fragment>
            )
        });

        return cardRows
    }




    render() {

        return (
            <section className="IntegrationOverviewSection">
                <div className="col-lg-12 pl-0 pr-0">
                    <Breadcrumb {...integrationCrumb} />
                </div>
                <div className="pb-2">
                    <div className="row m-0 pt-4 pb-2 pl-3 pr-4">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="d-flex" style={{ width: "90vw", position: "relative" }}>
                                <h2 className="pageTitle">&nbsp; Integration Overview</h2>
                            </div>
                        </div>
                    </div>
                    <div className="pb-0 pl-4 pr-4">
                        <Header
                            typeOptions={this.props.typeOptions}
                        />
                    </div>

                    <div className="row m-0 pt-1 pl-4 pr-4">
                        {this.createRows()}
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    let settings = state.common.applicationSettings;
    let additionalSettings = state.entity.additionalSettings;
    let store = state.common.store;
    let webMenuUISettings = state.entity.webMenuUISettings;
    let integrationList = LOOKUP.integrations.map(item => {
        let active = false
        switch (item.name) {
            case "Global Payments": active = settings.picEnabled; break;
            case "Elavon": active = settings.picEnabled; break;
            case "Paystone Payment": active = settings.paystoneInStoreEnabled; break;
            case "Moneris": active = settings.monerisEnabled; break;
            case "Merrco": active = settings.payFirmaEnabled; break;
            case "Birchmount": active = settings.birchmountGiftCardEnabled; break;
            case "CPOS PIC": active = settings.picEnabled; break;
            case "Paymentree": active = store.paymentreeInStoreEnabled; break;
            case "Dutchie": active = settings.dutchieIsEnabled; break;
            case "Leafly": active = settings.leaflyEnabled; break;
            case "Buddi": active = settings.buddiEnabled; break;
            case "Woocommerce": active = settings.wordpressEnabled; break;
            case "Alpine IQ": active = settings.alpineIQApiKey != null; break;
            case "Spring Big": active = settings.springbigApiKey != null; break;
            case "Sticky Cards": active = settings.stickyCardsEnabled; break;
            case "Weedmaps": active = settings.weedmapsEnable; break;
            case "Age Checker": active = webMenuUISettings != null ? webMenuUISettings.ageCheckerEnabled : false; break;
            case "Machool": active = additionalSettings != null ? additionalSettings.machoolEnabled : false; break;
            case "Store to Door": active = webMenuUISettings != null ? webMenuUISettings.enableStoreToDoor : false; break;
            case "Twilio": active = settings.ownTwilioEnabled; break;
            case "Canna Collective": active = additionalSettings != null ? additionalSettings.cannaCollectiveEnabled : false; break;
            case "Independent Retail Cannabis Collective": active = additionalSettings != null ? additionalSettings.irccEnabled : false; break;
            case "Headset": active = additionalSettings != null ? additionalSettings.headSetEnabled : false; break;
            case "Canna Drop": active = false; break;
            case "UBI Communications": active = settings.digitalSignageEnabled; break;
            case "Budvue": active = additionalSettings != null ? additionalSettings.budvueEnabled : false; break;
            case "BudSense": active = additionalSettings != null ? additionalSettings.budSenseEnabled : false; break;
            case "SoLink": active = additionalSettings != null ? additionalSettings.soLinkEnabled : false; break;
            case "QuickBooks": active = additionalSettings != null ? additionalSettings.quickBooksEnabled : false; break;
        }

        return ({ active: active, name: item.name, type: item.type, description: item.description, imgLink: item.imgLink })
    })

    let uniqueTypes = new Set(integrationList.flatMap(item => item.type))
    let typeOptions = Array.from(uniqueTypes).map(item => {
        return { text: item, value: item }
    })
    typeOptions.sort((a, b) => a.text.localeCompare(b.text))
    typeOptions.unshift({ text: "All", value: "0" })


    return {
        branchId: state.common.branchId,
        typeOptions: typeOptions,
        integrationList: integrationList,
        selectedType: state.form.integrationSelectedType,
        nameFilter: state.form.integrationNameFilter
    };
};

const mapDispatchToProps = dispatch => {

    return {
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getWebUISettings: (branchId, compName) => dispatch(getWebUISettings(branchId, compName)),
        getSettingsIntegration: (branchId) => dispatch(getSettingsIntegration(branchId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationOverview);